import styled from "@emotion/styled";
import { BorderRadius, Colors, Fonts, Spacing } from "@snapchat/snap-design-system";

import { Flexbox } from "../../../../shared/components";

export const LensSubmissionErrorMessageItemBody = styled.div`
    ${Fonts.Paragraph.P300};
    color: ${Colors.Gray.V300};

    > p {
        margin-bottom: ${Spacing.SM}px;
    }

    > * {
        margin-bottom: ${Spacing["2XS"]}px;
    }

    ul {
        padding-left: ${Spacing.MD}px;
    }

    pre {
        margin-top: 0;
        padding: ${Spacing.XS}px;

        color: ${Colors.WHITE};
        white-space: pre-wrap;

        background-color: ${Colors.Black.V100};
        border-radius: ${BorderRadius.container}px;
    }
`;

export const LensSubmissionErrorMessageItemContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${Spacing.XS}px 0;

    &:not(:first-child) {
        border-top: 1px solid ${Colors.Gray.V50};
    }

    :last-child {
        border-bottom: 1px solid ${Colors.Gray.V50};
    }
`;

export const LensSubmissionErrorMessageItemContent = styled(Flexbox)`
    max-width: calc(100% - 20px);
`;

export const LensSubmissionErrorMessageItemTitle = styled.h4`
    margin-bottom: ${Spacing.XS}px;
    ${Fonts.Heading.H700};
`;

export const WarningSection = styled.div`
    padding-top: ${Spacing["3XS"]}px;
    padding-left: ${Spacing["2XS"]}px;
`;
